interface NameFieldProps {
  readonly value: string;
  readonly onChange: (value: string) => void;
  readonly duplicateOfExisting?: boolean;
}

const MAX_LEN = 24;

export function NameField({ value, onChange, duplicateOfExisting }: NameFieldProps) {
  return (
    <div className="theme-editor__section theme-editor__section--name">
      <label>
        <span>Nimi</span>
        <input
          type="text"
          value={value}
          maxLength={MAX_LEN}
          onChange={(e) => onChange(e.target.value)}
        />
      </label>
      {duplicateOfExisting ? <p className="theme-editor__hint">Teemalla on jo tämä nimi.</p> : null}
    </div>
  );
}
